<div class="relative max-w-full">
  @if (label()) {
    <label
      [for]="label()"
      class="absolute text-xs -top-2 left-3 z-10 bg-white px-1 rounded-md transition duration-300 font-medium text-neutral-700">
      {{ label() }}
    </label>
  }

  <button
    type="button"
    [disabled]="isDisabled"
    (click)="toggleOpen()"
    class="h-full py-2 px-3 block border border-neutral-700 rounded-lg sm:text-sm focus:ring-0 focus:outline-primary-80 appearance-none bg-white placeholder:text-neutral-700 nth-*:text-neutral-700 min-w-full bg-[url('/assets/chevron-down.svg')] bg-size-[16px] bg-position-[right_8px_center] bg-no-repeat pr-7 max-w-full text-ellipsis text-left"
    [class.opacity-50]="isDisabled"
    [class.cursor-not-allowed]="isDisabled"
    [class.cursor-pointer]="!isDisabled">
    {{ placeholder() }}
  </button>

  <p class="mt-1 text-sm font-light text-neutral-700">
    ({{ selectedCount() }}) recipients selected.
  </p>

  @if (isOpen()) {
    <div
      class="absolute z-30 mt-1 w-full bg-white border border-neutral-800 rounded-lg shadow-xl overflow-hidden">
      <div class="p-2">
        <input
          type="text"
          [ngModel]="search()"
          (ngModelChange)="onSearchChange($event)"
          [placeholder]="searchPlaceholder()"
          class="w-full px-2 py-1.5 border-b border-neutral-200 focus:outline-primary-80 focus:ring-0 placeholder:text-neutral-500" />
      </div>

      <div class="max-h-40 overflow-auto">
        @if (filteredOptions().length === 0) {
          <div class="px-3 pb-3 text-sm text-neutral-500">No results.</div>
        } @else {
          <div class="px-2 pb-2 flex flex-col gap-1">
            @for (option of filteredOptions(); track option.value) {
              <button
                type="button"
                (click)="toggleSelection(option.value)"
                class="w-full flex items-center justify-between px-3 py-2 rounded-lg border text-left"
                [class.bg-primary-100]="isSelected(option.value)"
                [class.border-primary-500]="isSelected(option.value)"
                [class.border-neutral-200]="!isSelected(option.value)">
                <span
                  class="text-neutral-900"
                  [class.text-neutral-950]="isSelected(option.value)"
                  [class.font-bold]="isSelected(option.value)">
                  {{ option.label }}
                </span>

                @if (isSelected(option.value)) {
                  <icon name="check" class="text-primary-700" [size]="18" />
                }
              </button>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
